import { configureStore } from "@reduxjs/toolkit";
import LayoutReducers from "./Reducers/Layout/LayoutReducers";
import ThemeCustomizerReducers from "./Reducers/Layout/ThemeCustomizerReducers";
import authReducer from "./Reducers/Layout/AuthReducer";
import userRoleReducer from './Reducers/UserRole/UserRoleReducer'

export const store = configureStore({
  reducer: {
    layout: LayoutReducers,
    themeCustomizer: ThemeCustomizerReducers,
    auth: authReducer,
    authRoles: userRoleReducer, 
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;